// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"styles_pageWrapper__3Gdxg","input":"styles_input__2hu0y"};